import axios from "axios";

const API_URL = "https://supadaa.com/api/";

const authHeaders = (extra = {}) => ({
  Accept: "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  ...extra,
});

const getAll = async (params = {}) => {
  const res = await axios.get(`${API_URL}products`, {
    headers: authHeaders(),
    params,
  });
  return res.data;
};

// id body ma jase: {id}
const getOne = async (id) => {
  const res = await axios.post(
    `${API_URL}products/show`,
    { id },
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res.data;
};

const create = async (formData) => {
  const res = await axios.post(`${API_URL}products/create`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });
  return res.data;
};

// formData ma 'id' append karelu hase
const update = async (formData) => {
  const res = await axios.post(`${API_URL}products/update`, formData, {
    headers: authHeaders({ "Content-Type": "multipart/form-data" }),
  });
  return res.data;
};

// id body ma jase: {id}
const remove = async (id) => {
  const res = await axios.post(
    `${API_URL}products/delete`,
    { id },
    { headers: authHeaders({ "Content-Type": "application/json" }) }
  );
  return res.data;
};

export default { getAll, getOne, create, update, remove };